var map = {
	"./alert-circle.svg": "7851",
	"./angular.svg": "9451",
	"./back-money.svg": "8952",
	"./bar-chart.svg": "aac4",
	"./blog2.svg": "d729",
	"./blogger.svg": "15c8",
	"./book.svg": "a337",
	"./bootstrap.svg": "2ea3",
	"./brush.svg": "815f",
	"./cameraVideo.svg": "08ca",
	"./campaign-dashboard.svg": "a3d1",
	"./chat-bot.svg": "df8f",
	"./chat.svg": "1666",
	"./coin.svg": "75c7",
	"./compass.svg": "b49e",
	"./congratulations.svg": "de75",
	"./diamond.svg": "dee6",
	"./dollar-empty.svg": "be20",
	"./dollar-full.svg": "7b85",
	"./dots-default-profile.svg": "901f",
	"./facebook2.svg": "8d54",
	"./facebook_white.svg": "a78c",
	"./figma.svg": "7472",
	"./filterx.svg": "61d6",
	"./flash-dashboard.svg": "3041",
	"./gender-chart.svg": "f99a",
	"./google.svg": "e351",
	"./grid.svg": "5113",
	"./hired.svg": "b8bb5",
	"./historyClock.svg": "7bdb",
	"./ia.svg": "2f9d",
	"./imageIcon.svg": "1394",
	"./influence_man.svg": "79a6",
	"./info.svg": "3e95",
	"./insta_white.svg": "eb9e",
	"./instagram2.svg": "bee3",
	"./job_offer.svg": "f550",
	"./linkedin2.svg": "a6fa",
	"./linkedin_white.svg": "a8e1",
	"./magic.svg": "186a",
	"./marketing-enginees.svg": "766be",
	"./message.svg": "2931",
	"./mistery.svg": "a816",
	"./moneda-black.svg": "b87c",
	"./moneda.svg": "9efc",
	"./parachute.svg": "666b",
	"./pinterest.svg": "8554",
	"./pinterest2.svg": "61ab",
	"./pinterest_white.svg": "f486",
	"./react.svg": "f4d6",
	"./reddit_icon_white.svg": "51dc",
	"./rocket.svg": "df02",
	"./snapchat.svg": "2e9c",
	"./snapchat2.svg": "5c29",
	"./snapchat_white.svg": "72a4",
	"./speaker.svg": "1535",
	"./spotify.svg": "1a9b",
	"./spotify2.svg": "c657",
	"./spotify_white.svg": "730a",
	"./star.svg": "0a83",
	"./stars.svg": "ba4d",
	"./telegram_white.svg": "a752",
	"./text.svg": "f1f5",
	"./tiktok.svg": "b612",
	"./tiktok2.svg": "e271",
	"./tiktok_white.svg": "a5be",
	"./toolbox.svg": "40d5c",
	"./twitch2.svg": "81f8",
	"./twitch_white.svg": "a489",
	"./twitter-x-black.svg": "45ff",
	"./twitter-x-circle.svg": "236c",
	"./twitter-x-gray.svg": "f786",
	"./twitter-x.svg": "be91",
	"./twitter2.svg": "c476",
	"./upc.svg": "2ceb",
	"./user-dashboard.svg": "6b65",
	"./video.svg": "bff0",
	"./vuejs.svg": "57c1",
	"./whatsapp_white.svg": "f3f1",
	"./wordpress-icon-white.svg": "b99e",
	"./wordpress-icon.svg": "8506",
	"./youtube-shorts.svg": "c263",
	"./youtube-video.svg": "cf83",
	"./youtube2.svg": "8745",
	"./youtube_white.svg": "4e18",
	"./yt_shorts.svg": "77f7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5981";